// User registration bundle
import '../css/vendor/jquery.passwordRequirements.css';
import '../css/vendor/chosen.css';
import '../css/pages/user/registration/account-information.css';

// Note: zxcvbn is kept as external CDN load in the controller (not bundled).
import { runLegacy } from './helpers/load-legacy';
import passwordRequirementsJs from '../js/vendor/jquery.passwordRequirements.js?legacy';
import chosenJs               from '../js/vendor/chosen.jquery.min.js?legacy';
import bootboxJs              from '../js/vendor/bootbox.min.js?legacy';
import latinizeJs             from '../js/vendor/latinize.js?legacy';
import loginProcessJs         from '../js/global/login-process.js?legacy';
import passwordResetJs        from '../js/vendor/password-reset.js?legacy';
import crossStateZipsJs       from '../js/global/cross-state-zips.js?legacy';
import adressJs               from '../js/pages/user/account/adress.js?legacy';

runLegacy(
    passwordRequirementsJs,
    chosenJs,
    bootboxJs,
    latinizeJs,
    loginProcessJs,
    passwordResetJs,
    crossStateZipsJs,
    adressJs,
);
